import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Icons";
import { navLinks } from "../data";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const location = useLocation();

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-white/90 shadow-[0_4px_30px_rgba(15,118,110,0.08)] backdrop-blur-md"
          : "bg-transparent"
        }`}
    >
      {/* utility bar */}
      <div
        className={`hidden border-b border-white/10 text-xs transition-colors md:block ${scrolled ? "border-slate-200/70 text-slate-500" : "text-white/70"
          }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-1.5">
          <span>Precision Construction Machinery · Since 1976</span>
          <div className="flex items-center gap-4">
            <a className="transition hover:text-teal-500" href="#">Twitter</a>
            <a className="transition hover:text-teal-500" href="#">LinkedIn</a>
            <a className="transition hover:text-teal-500" href="#">Facebook</a>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <Logo />
        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.name}
                to={link.path}
                className={`group relative text-sm font-medium transition ${scrolled ? "text-slate-700" : "text-white/90"
                  } hover:text-teal-500`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-teal-500 transition-all ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`} />
              </Link>
            );
          })}
          <a
            href="/contact"
            className="rounded-md bg-teal-600 px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-teal-500"
          >
            Get a Quote
          </a>
        </nav>
        <button
          onClick={() => setOpen(!open)}
          className={`lg:hidden ${scrolled ? "text-slate-800" : "text-white"}`}
          aria-label="Menu"
        >
          <svg className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
            <path strokeLinecap="round" d="M4 7h16M4 12h16M4 17h16" />
          </svg>
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white px-6 py-4 lg:hidden">
          <div className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link key={link.name} to={link.path} className="text-sm font-medium text-slate-700" onClick={() => setOpen(false)}>
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
